import { BASE_URL } from "src/constants/vars";
import { setCredentials, logOut } from "../reducers/auth";
import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';
import { clearAuthStorage } from "src/utils/auth";
import i18n from "src/setup/i18n";
import { MALEK_STORE_TOKEN_KEY } from "src/constants/storageKeys";


const baseQuery = fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState }: { getState: any }) => {
        const accessToken = getState().auth.access;
        if (accessToken) {
            headers.set("Authorization", `Bearer ${accessToken}`);
        }
        headers.set('Accept-Language', i18n.language);
        return headers
    }
})

const logOutAction = (api: any) => {
    api.dispatch(logOut());
    clearAuthStorage();
}

const baseQueryWithReauth: typeof baseQuery = async (args, api: any, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);

    if (result.error?.status === 401) {
        // 1️⃣ Get refresh token from Redux state
        const stateRefreshToken = api.getState().auth?.refresh;

        // 2️⃣ Get refresh token from local storage
        const localStorageRefreshToken = localStorage.getItem(MALEK_STORE_TOKEN_KEY);

        // 3️⃣ Use whichever exists
        const refreshToken = stateRefreshToken || localStorageRefreshToken;

        if (refreshToken) {
            try {
                const response = await fetch(`${BASE_URL}/auth/refresh/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        refresh: refreshToken,
                    }),
                });

                if (!response.ok) throw new Error("Refresh token invalid");

                const { access, refresh } = await response.json();

                // Save the new tokens to Redux
                api.dispatch(setCredentials({
                    ...api.getState().auth,
                    access,
                    refresh: refresh || refreshToken, // keep existing refresh if backend doesn't return it
                }));

                // Optionally update localStorage
                localStorage.setItem(MALEK_STORE_TOKEN_KEY, refresh || refreshToken);

                // Retry the original query
                result = await baseQuery(args, api, extraOptions);
            }
            catch (error) {
                logOutAction(api);
            }
        }
        else {
            logOutAction(api);
        }
    }

    return result;
};



const apiSlice = createApi({
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({

    })
})

export default apiSlice;

